import { render, staticRenderFns } from "./DataStatistic.vue?vue&type=template&id=3cd756a0&scoped=true&"
import script from "./DataStatistic.vue?vue&type=script&lang=js&"
export * from "./DataStatistic.vue?vue&type=script&lang=js&"
import style0 from "./DataStatistic.vue?vue&type=style&index=0&id=3cd756a0&lang=scss&scoped=true&"
import style1 from "./DataStatistic.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd756a0",
  null
  
)

component.options.__file = "DataStatistic.vue"
export default component.exports